import { render } from "./Edit.svg?vue&type=template&id=1d4c16fc"
const script = {}
script.render = render

export default script